import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../shared/components/Button';
import { supabaseClient } from '../../../shared/utils/supabaseClient';

const WelcomeScreen = ({ onNext }) => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      console.log('🔚 Signing out...');
      await supabaseClient.auth.signOut();
      localStorage.removeItem('userRole');
      localStorage.removeItem('user');
      navigate('/signin');
      console.log('✅ Signed out successfully');
    } catch (error) {
      console.error('❌ Error signing out:', error);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 py-8 bg-gradient-to-b from-neutral-100 to-neutral-50">
      {/* Sign Out Button */}
      <div className="absolute top-4 right-4">
        <button
          onClick={handleSignOut}
          className="text-sm text-neutral-500 hover:text-neutral-700 font-medium bg-neutral-100 px-3 py-1 rounded-lg shadow-sm"
        >
          Sign Out
        </button>
      </div>
      {/* EsuSol Logo and Name */}
      <div className="mb-8 text-center">
        <div className="w-20 h-20 bg-primary-600 rounded-full flex items-center justify-center mb-4 mx-auto">
          <span className="text-neutral-50 text-3xl font-bold">E</span>
        </div>
        <h1 className="text-4xl font-bold text-neutral-900 mb-2">EsuSol</h1>
      </div>

      {/* Welcome Content */}
      <div className="max-w-md w-full text-center space-y-6">
        <h2 className="text-2xl font-semibold text-neutral-900">
          Welcome to EsuSol 👋
        </h2>
        
        <p className="text-lg text-neutral-600">
          Set up your first savings group in under 3 minutes
        </p>

        <div className="pt-8">
          <Button
            onClick={onNext}
            variant="primary"
            size="lg"
            className="w-full text-lg py-4"
          >
            Get Started →
          </Button>
        </div>

        {/* Trust Indicators */}
        <div className="mt-12 space-y-4">
          <div className="flex items-center justify-center space-x-2 text-sm text-neutral-500">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            <span>No money held or processed</span>
          </div>
          <div className="flex items-center justify-center space-x-2 text-sm text-neutral-500">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            <span>One hand = one registered member</span>
          </div>
          <div className="flex items-center justify-center space-x-2 text-sm text-neutral-500">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            <span>No income verification required</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
